import { Link } from '@tonic-one/react';
import { PermissionNameEnum } from '@Types/permissions';
import { useOrgStore } from '@Models/useOrgModel';
import { usePermissionStore } from '@Models/usePermissionModel';
import { ES_SERVICE_NAME_TO_POLICY_TYPE } from '@Utils/service';
import SmartTooltip from '@Report/SmartTooltip';
import { PolicyApi } from '@Apis';
import { useTranslation } from 'react-i18next';
import { PolicyHolderTypeEnum, PolicyItem } from '@Policy/utils/types';
import { isInUIC } from '../../../utils/common';
import config from 'src/config';

export const PolicyName = ({ logItem }: { logItem: any }) => {
  const { t } = useTranslation();
  const { companyGuid = '', policy = '', scanSourceKey } = logItem;
  const { orgsMap } = useOrgStore();
  const { widthReadablePermission } = usePermissionStore();
  const policyReadPermission =
    widthReadablePermission(PermissionNameEnum.atpPolicy) ||
    widthReadablePermission(PermissionNameEnum.dlpPolicy);
  const policyType = ES_SERVICE_NAME_TO_POLICY_TYPE.get(scanSourceKey);

  if (
    !policyReadPermission ||
    !companyGuid ||
    !orgsMap.get(companyGuid) ||
    !policy ||
    !policyType ||
    scanSourceKey === 'Exchange Server'
  ) {
    return <SmartTooltip>{policy}</SmartTooltip>;
  }

  const linkToPolicy = async () => {
    let policies: PolicyItem[] = [];
    try {
      policies = (
        await PolicyApi.apiSearchPolices(companyGuid, {
          policyName: policy,
          policyType,
        })
      ).data;
    } catch {
      console.error('apiSearchPolices failed');
    }
    if (policies.length === 0) {
      window.showNotification({
        severity: 'warning',
        titleMsg: t('errors:errors.policy.policyNotExist'),
      });
    } else {
      const { holderType, policyUuid } = policies[0];
      const path =
        holderType === PolicyHolderTypeEnum.ATP
          ? 'policy/advanced-threat-protection/'
          : 'policy/data-loss-prevention/';
      const url = path + `edit-policy/${policyUuid}`;
      if (isInUIC()) {
        window.open(`/#${config.ui.uicPrefix}/${url}`, '_blank');
      } else {
        window.open(`${config.ui.prefix}/${url}`, '_blank');
      }
    }
  };

  return (
    <Link
      onClick={linkToPolicy}
      title={t('log:log.hint.viewPolicy')}
      width="100%"
    >
      <SmartTooltip>{policy}</SmartTooltip>
    </Link>
  );
};
